<template>
  <div v-if="show" class="k-search-overlay" @click.self="close">
    <div class="k-search-modal">
      <div class="k-search-input-wrapper">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          ref="searchInput"
          :value="value"
          @input="$emit('input', $event.target.value)"
          type="text"
          class="k-search-input"
          placeholder="Suchen..."
          @keydown.esc="close"
        />
        <kbd class="k-search-kbd">ESC</kbd>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * NavbarSearch - Search modal component
 * @description Full-screen search modal with keyboard support
 * @prop {Boolean} show - Controls modal visibility
 * @prop {String} value - Current search query value
 * @emits close - When modal should close
 * @emits input - When search input changes
 */
export default {
  name: "NavbarSearch",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
  },
  watch: {
    /**
     * Focus input when modal opens
     * @param {Boolean} newVal - New show value
     */
    show(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.searchInput?.focus();
        });
      }
    },
  },
  methods: {
    /**
     * Emits close event to parent
     */
    close() {
      this.$emit("close");
    },
  },
};
</script>

